import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import FileIcon from '../assets/FileIcon';
import UgskLogo from 'shared/assets/UgskLogo';
import styles from 'features/processing-policy/ui/ProcessingPolicy.module.css';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export const ProcessingPolicy: React.FC = () => {

  const [open, setOpen] = useState(false);

  const handleOpenText = () => {
    setOpen((prevState) => !prevState)
  }

  if (open) {
    return (
      <Box>
        <Box className={styles.headerBox}>
          <Box className={styles.border}>
            <UgskLogo />
            <Button onClick={handleOpenText} className={styles.btnBack}><KeyboardBackspaceIcon /> Назад </Button>
          </Box>
        </Box>
        <Box className={styles.textContent}>
          <Box className={styles.titleBox}>
            <h1>Политика конфиден&shy;циальности</h1>
            <p>Дата: 26.06.2025</p>
          </Box>
          <Box className={styles.textBox}>
            <Box className={styles.mt10}>
              <p>Настоящий документ «Политика конфиден&shy;циальности» (далее по тексту – «Политика») представляет собой правила использования данных интернет-пользователей
                (далее «вы» и/или «Пользователь»), собираемых с использованием мобильного приложения (далее – «МП»).
              </p>
            </Box>
            <Box className={styles.itemText}>
              <h3>1. Обрабаты&shy;ваемые данные</h3>
              <p><span>1.1</span> Все данные, собираемые в МП, предоставляются Пользователем добровольно и обрабатываются в соответствии с настоящей политикой, внутренними
                правилами и регламентами и законодательством Российской Федерации.
              </p>
              <p><span>1.2</span> Собранные данные используются для целей владельца МП и не передаются на сторонние ресурсы, за исключением статистической информации, при
                передаче которой данные обезличиваются и не позволяют идентифицировать Пользователя.
              </p>
              <p><span>1.3</span> Администрация вправе устанавливать требования к составу данных Пользователя, которые собираются использованием МП.
              </p>
              <p><span>1.4</span> Пользователь дает информированное согласие на обработку его персональных данных в момент начала их предоставления с
                использованием МП.
              </p>
              <p><span>1.5</span> Если определенная информация не помечена как обязательная, ее предоставление осуществляется Пользователем на свое усмотрение.
              </p>
              <p><span>1.6</span> Администрация не осуществляет проверку достоверности предоставляемых данных, полагая, что Пользователь действует добросовестно,
                осмотрительно и прилагает все необходимые усилия к поддержанию такой информации в актуальном состоянии.
              </p>
              <p><span>1.7</span> Вы осознаете и принимаете возможность использования на МП программного обеспечения третьих лиц, в результате чего такие лица
                могут получать и передавать указанные в п.1.3 данные в обезличенном виде.
              </p>
              <p><span>Пример!</span> К указанному программному обеспечению третьих лиц относятся системы сбора статистики посещений Google Analytics и Яндекс.Метрика.
              </p>
              <p><span>1.8</span>  Состав и условия сбора обезличенных данных с использованием программного обеспечения третьих лиц определяются непосредственно их
                правообладателями и могут включать:
              </p>
              <ul>
                  <li>данные программы (тип, версия);</li>
                  <li>данные устройства и место его положения;</li>
                  <li>данные операционной системы (тип, версия, разрешение экрана);</li>
                  <li>данные запроса (время, источник перехода, IP-адрес).</li>
                </ul>
              <p><span>1.9</span>  Администрация не несет ответственность за порядок использования статистических обезличенных данных Пользователя третьими лицами.
              </p>
            </Box>
            <Box className={styles.itemText}>
              <h3>2. Цели обработки данных</h3>
              <p><span>2.1</span> Администрация использует данные в следующих целях:</p>
              <ul>
                  <li>Обработка поступающих запросов и связи с Пользователем;</li>
                  <li>Информационное обслуживание, включая рассылку рекламно-информационных материалов;</li>
                  <li>Проведение маркетинговых, статистических и иных исследований;</li>
                  <li>Таргетирование рекламных материалов в МП.</li>
                </ul>
            </Box>
            <Box className={styles.itemText}>
              <h3>3. Требования к защите данных</h3>
              <p><span>3.1</span> Администрация осуществляет хранение данных и обеспечивает их охрану от несанкциониро&shy;ванного доступа и распространения
                в соответствии с внутренними правилами и регламентами и законодательством Российской Федерации.
              </p>
              <p><span>3.2</span> В отношении полученных данных сохраняется конфиден&shy;циальность, за исключением случаев, когда они самостоятельно сделаны
                Пользователем общедоступными.
              </p>
              <p><span>3.3</span> В целях повышения качества работы Администрация вправе хранить лог-файлы о действиях, совершенных Пользователем в рамках
                использования МП в течение 1 (Одного) года.
              </p>
            </Box>
            <Box className={styles.itemText}>
              <h3>4. Передача данных</h3>
              <p><span>4.1</span> Администрация вправе передать данные третьим лицам в следующих случаях:</p>
              <ul>
                  <li>Пользователь выразил свое согласие на такие действия, включая случаи применения Пользователем настроек используемого
                    программного обеспечения, не ограничивающих предоставление определенной информации;</li>
                  <li>Передача необходима в рамках использования Пользователем функциональных возможностей МП;</li>
                  <li>Передача требуется в соответствии с целями обработки данных;</li>
                  <li>В связи с передачей МП во владение, пользование или собственность такого третьего лица;</li>
                  <li>По запросу суда или иного уполномоченного государственного органа в рамках установленной законода&shy;тельством процедуры;</li>
                  <li>Для защиты прав и законных интересов Администрации в связи с допущенными Пользователем нарушениями.</li>
                </ul>
            </Box>
            <Box className={styles.itemText}>
              <h3>5. Изменение Политики конфиден&shy;циальности</h3>
              <p><span>5.1</span> Настоящая Политика может быть изменена Администрацией в одностороннем порядке без предварительного уведомления Пользователя. Новая редакция Политики вступает
                в силу с момента ее размещения на МП, если иное не предусмотрено новой редакцией Политики.
              </p>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      <Box className={styles.headerBox}>
        <Box className={styles.border}>
          <UgskLogo />
        </Box>
      </Box>
      <Box className={styles.contentBox}>
        <Box className={styles.titleBox}>
          <h1>Политика конфиден&shy;циальности АО «СК «Югория»</h1>
        </Box>
        <Box className={styles.filesBox}>
          <Box className={styles.FileItemBorder}>
            <span><FileIcon /></span>
            <a
              onClick={handleOpenText}
            >
              Политика конфиден&shy;циальности (Privacy policy)
            </a>
          </Box>
          <Box className={styles.FileItemBorder}>
            <span><FileIcon /></span>
            <a
            href="/policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >
              Политика конфиден&shy;циальности в PDF (Privacy policy pdf)
            </a>
          </Box>
          <Box className={styles.FileItem}>
            <span><FileIcon /></span>
            <a
              href="/agree.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Согласие на обработку персональ&shy;ных данных в PDF (Processing of personal data pdf)
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProcessingPolicy;
